import axios from "../../request";

const REGIST_LICENSE = 'system/registlicence';
const GET_MACHINENUMBER = 'system/getmachinenumber';


export const registLicense = (params) => axios.post(REGIST_LICENSE, params);
export const getMachineNumber = () => axios.get(GET_MACHINENUMBER);